module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "exams-disabled.24d38406.png";